export { TypeofPipe } from './typeof.pipe';
